import styled from 'styled-components'
import theme from '../../styles/theme'
export const StyledInput = styled.div`
  padding: 0px;
  @media (min-height: 700px) {
    padding: 20px 0px;
  }
`
export const InputLabel = styled.label`
  font-weight: 700;
  margin-bottom: 0px;
  color: ${theme.color.black};
  display: block;
  font-size: 16px;
  line-height: 1.5;
`
export const Input = styled.input`
  margin-top: 0.25rem;
  box-sizing: border-box;
  font-size: 1rem;
  line-height: 1;
  padding: 0.5rem 1rem;
  height: 2.875rem;
  border: 3px solid gray;
  background-color: ${theme.color.white};
  color: ${theme.color.black};
  border-radius: 4px;
  vertical-align: middle;
  appearance: none;
  width: 100%;
`

export const InputText = styled.p`
  margin-top: 20px;
  margin-bottom: 20px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.color.black};
  & > button {
    background: transparent;
    border: none;
    text-decoration: underline;
    font-size: 1rem;
    line-height: 1.5;
    color: ${theme.color.btnText};
  }
`
